import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill out this field.'}
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill out this field.'}
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill out this field.'},
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please fill out this field.'},
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    theme: {
      validations: []
    },
    addressline1: {
      validations: []
    },
    state: {
      validations: []
    },
    city: {
      validations: []
    },
    postal: {
      validations: []
    },
    accountextra4: {
      validations: []
    },
    accountextra5: {
      validations: []
    },
    reference: {
      validations: [
        { type: 'required', message: 'Please fill out this field.'}
      ]
    },
    accountextra3: {
      validations: []
    },
    siteName: {
      validations: [      
        { type: 'required', message: 'Please fill out this field.'}
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    plannedguestcount: {
      validations: []
    },  
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address',
            mapping: 'addressline1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State',
            options: [
              { label: 'Alabama', value: 'AL' },
              { label: 'Alaska', value: 'AK' },
              { label: 'Arizona', value: 'AZ' },
              { label: 'Arkansas', value: 'AR' },
              { label: 'American Somoa', value: 'AS' },              
              { label: 'California', value: 'CA' },
              { label: 'Colorado', value: 'CO' },
              { label: 'Connecticut', value: 'CT' },
              { label: 'Delaware', value: 'DE' },
              { label: 'District of Columbia', value: 'DC' },
              { label: 'Florida', value: 'FL' },
              { label: 'Georgia', value: 'GA' },
              { label: 'Hawaii', value: 'HI' },
              { label: 'Idaho', value: 'ID' },
              { label: 'Illinois', value: 'IL' },
              { label: 'Indiana', value: 'IN' },
              { label: 'Iowa', value: 'IA' },
              { label: 'Kansas', value: 'KS' },
              { label: 'Kentucky', value: 'KY' },
              { label: 'Louisiana', value: 'LA' },
              { label: 'Maine', value: 'ME' },
              { label: 'Maryland', value: 'MD' },
              { label: 'Massachusetts', value: 'MA' },
              { label: 'Michigan', value: 'MI' },
              { label: 'Minnesota', value: 'MN' },
              { label: 'Mississippi', value: 'MS' },
              { label: 'Missouri', value: 'MO' },
              { label: 'Northern Mariana Islands', value: 'NMI' },
              { label: 'Montana', value: 'MT' },
              { label: 'National', value: 'National' },
              { label: 'Nebraska', value: 'NE' },
              { label: 'Nevada', value: 'NV' },
              { label: 'New Hampshire', value: 'NH' },
              { label: 'New Jersey', value: 'NJ' },
              { label: 'New Mexico', value: 'NM' },
              { label: 'New York', value: 'NY' },
              { label: 'North Carolina', value: 'NC' },
              { label: 'North Dakota', value: 'ND' },
              { label: 'Ohio', value: 'OH' },
              { label: 'Oklahoma', value: 'OK' },
              { label: 'Oregon', value: 'OR' },
              { label: 'Pennsylvania', value: 'PA' },
              { label: 'Puerto Rico', value: 'PR' },
              { label: 'Rhode Island', value: 'RI' },
              { label: 'South Carolina', value: 'SC' },
              { label: 'South Dakota', value: 'SD' },
              { label: 'Tennessee', value: 'TN' },
              { label: 'Texas', value: 'TX' },
              { label: 'Utah', value: 'UT' },
              { label: 'Vermont', value: 'VT' },
              { label: 'Virginia', value: 'VA' },
              { label: 'Virgin Islands', value: 'VI' },
              { label: 'Washington', value: 'WA' },
              { label: 'West Virginia', value: 'WV' },
              { label: 'Wisconsin', value: 'WI' },
              { label: 'Wyoming', value: 'WY' }
            ],
            mapping: 'state'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City',
            mapping: 'city'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip',
            mapping: 'postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Birthday Month',
            options: [
              { label: 'January', value: 'January'},
              { label: 'February', value: 'February'},                                          
              { label: 'March', value: 'March'},
              { label: 'April', value: 'April'},
              { label: 'May', value: 'May'},                                          
              { label: 'June', value: 'June'},
              { label: 'July', value: 'July'},
              { label: 'August', value: 'August'},                                          
              { label: 'September', value: 'September'},
              { label: 'October', value: 'October'},
              { label: 'November', value: 'November'},                                          
              { label: 'December', value: 'December'}
            ],
            mapping: 'accountextra4'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Anniversary Month',
            options: [
              { label: 'January', value: 'January'},
              { label: 'February', value: 'February'},                                          
              { label: 'March', value: 'March'},
              { label: 'April', value: 'April'},
              { label: 'May', value: 'May'},                                          
              { label: 'June', value: 'June'},
              { label: 'July', value: 'July'},
              { label: 'August', value: 'August'},                                          
              { label: 'September', value: 'September'},
              { label: 'October', value: 'October'},
              { label: 'November', value: 'November'},                                          
              { label: 'December', value: 'December'}                                          
            ],
            mapping: 'accountextra5'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event',
            options: [
              { label: 'Wedding', value: 'Wedding'},
              { label: 'Special Event', value: 'Special Event'},                                          
              { label: 'Corporate', value: 'Corporate'}
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Expected Number of Guests',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How Did You Hear About Us?',
            options: [
              { label: 'The Knot', value: 'The Knot'},
              { label: 'Wedding Wire', value: 'Wedding Wire'},                                          
              { label: 'Wedding Spot', value: 'Wedding Spot'},
              { label: 'Google', value: 'Google'},
              { label: 'Facebook, Instagram', value: 'Facebook, Instagram'},                                          
              { label: 'Email', value: 'Email'},
              { label: 'Wedding', value: 'Wedding'},
              { label: 'Friends or Family', value: 'Friends or Family'},                                          
              { label: 'Previous guest', value: 'Previous guest'},
              { label: 'Other', value: 'Other'}
            ],
            mapping: 'reference'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Other',
            mapping: 'accountextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Venue',
            options: [
              { label: 'Russo', value: 'Russo'},
              { label: 'Vetro', value: 'Vetro'}                                     
            ],
            mapping: 'siteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Comments',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Russo\'s on the Bay Catering Contact Form',
    formId: '281',
    clientKey: 'D89F3BAA-CF34-4255-8848-F62A87A5BBB2',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/russosonthebay/form_structure.js